/**
 * Change styling for input file
 */
const changeButtonFile = () => {
    const inputFile = document.querySelector("#form__input-file");
    if (inputFile) {
        inputFile.onchange = function () {
            const fileName = this.files[0]?.name;
            const label = document.querySelector("label[for=form__input-file]");
            label.innerText = fileName ?? label.textContent;
        };
    }
}

export { changeButtonFile };